import { Vector } from "p5";
import { ShapeMode } from "../../TypesAndConstants/types";
import ShapePicker from "./Brush/ShapeContructors";
const shapeSizeSS = 800
class Shape {
  brushSize: number;
  color: string;
  uiContext?: CanvasRenderingContext2D;
  canvasContext?: CanvasRenderingContext2D;
  isPressed = false;
  rotation: number = 0;
  p?: any;

  constructor(color: string) {
    this.brushSize = 25;
    this.color = color;
  }

  rotate(ang: number) {
    this.rotation = ang;
  }

  setContext(ctx: CanvasRenderingContext2D) {
    this.canvasContext = ctx;
  }

  setP5Inst(p5: any) {
    if (this.p === undefined) {
      this.p = p5;
    }
  }
  setIsPressed() {
    this.isPressed = !this.isPressed;
  }

  setBrushColor(color: string) {
    this.color = color;
  }

  setBrushSize(size: number) {
    this.brushSize = size;
  }

  display(
    c: any,
    shape: number,
    pos: Vector,
    mode: ShapeMode,
    mCoords: { x: number; y: number },
    image?: HTMLImageElement
  ) {
    if (this.canvasContext === undefined) {
      return;
    }
    this.p.push();
    this.p.noStroke();
    this.p.fill(c);
    this.p.beginShape();

    const mappedVal = this.p.map(
      this.brushSize,
      0,
      2000,
      0,
      shape === 1000 ? Math.floor(2000/shapeSizeSS) : 1.25
    );

    if (this.p.mouseIsPressed && mode === "rotation") {
      this.p.translate(pos.x - 100 * mappedVal, pos.y - 100 * mappedVal);
    }/* else if( shape === 1000 ) {
      const imageHeight = this.brushSize * ( image!.height / image!.width) 
      this.p.translate(
        mCoords.x - this.brushSize / 2,
        mCoords.y - imageHeight / 2
      );
    } */ else {
      this.p.translate(
        mCoords.x - 100 * mappedVal,
        mCoords.y - 100 * mappedVal
      );
    }

    this.p.applyMatrix(mappedVal, 0, 0, mappedVal, 0, 0);

    if (mode === "rotation") {
      let cos_a = this.p.cos(this.rotation);
      let sin_a = this.p.sin(this.rotation);
      this.p.applyMatrix(cos_a, sin_a, -sin_a, cos_a, 0, 0);
    }

    if (mode === "drag") {
      let cos_a = this.p.cos(this.rotation);
      let sin_a = this.p.sin(this.rotation);
      this.p.applyMatrix(cos_a, sin_a, -sin_a, cos_a, 0, 0);
    }

    ShapePicker(
      shape,
      this.p,
      this.brushSize,
      this.canvasContext,
      image,
      c._array[3]
    );

    this.p.endShape(this.p.CLOSE);
    this.p.pop();
  }
}

export default Shape;
